import { pageHead } from "@app/framework/meta";
import { aboutUsMockData } from "@modules/about-us/data/mockData";
import { AboutUsPage } from "@modules/about-us/pages";
import { trans } from "@mongez/localization";
import type { LoaderFunction, MetaFunction } from "@remix-run/node";
import { json } from "@remix-run/node";
import { useLoaderData } from "@remix-run/react";

export const loader: LoaderFunction = async ({ params }) => {
  return json(aboutUsMockData);
};

export default function AboutUs() {
  const data = useLoaderData<typeof loader>();

  return <AboutUsPage data={data} />;
}

export const meta: MetaFunction = ({ data }: any) => {
  return pageHead({
    title: data?.metaData?.title || trans("aboutUsPage.meta.title"),
    description:
      data?.metaData?.description || trans("aboutUsPage.meta.description"),
  });
};
